<!-- src/components/Header.vue -->
<template>
	<nav class="navbar navbar-light" :class="{ scrolled: isScrolled }" v-if="shouldShowHeader">
		<div class="container-fluid">
			<!-- LOGO -->
			<RouterLink to="/" @click="isMenuOpen = false" class="navbar-link"
				><img src="https://lineevent.s3.ap-northeast-1.amazonaws.com/Vespa_New180/images/logo.png" alt="LOGO"
			/></RouterLink>
			<!-- 漢堡按鈕 -->
			<button
				class="navbar-toggler"
				type="button"
				@click="isMenuOpen = !isMenuOpen"
				aria-controls="navbarText"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon" :class="{ active: isMenuOpen }"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarText" :class="{ show: isMenuOpen }">
				<Transition name="fade" appear>
					<ul class="navbar-nav me-auto mb-2 mb-lg-0 animation">
						<li v-for="(item, index) in menuItems" :key="index" class="nav-item">
							<button  @click="handleRouter(item)" >{{ item.name }}</button>
						</li>
						<!-- <button
							@click="
								store.showAlert('alertDanger', '核銷碼無效', {}, () => {})
							"
						>
							showAlert測試
						</button> -->
					</ul>
				</Transition>
			</div>
		</div>
	</nav>
</template>

<script setup>
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import APP_CONFIG from '@/config/config.js'
import { useStore } from '@/stores'
import { useGA } from '@/composables/useGA'

const router = useRouter()
const route = useRoute()
const store = useStore()
const {pushGAEvent} = useGA()
const isMenuOpen = ref(false)
const menuItems = [
	{ name: '兌換中心', path: '/redeem', gaName: '進入兌換中心' },
	{ name: '活動辦法', path: '/rules', gaName: '進入活動辦法' },
	{ name: '回首頁', path: '/' }
]

const handleRouter = (item) => {
	if(item.gaName){
		pushGAEvent(item.gaName)
	}
	
	isMenuOpen.value = false
	router.push(item.path)
}

const scrollY = ref(0)
const isScrolled = computed(() => scrollY.value > 20)

let scrollContainer = null

const handleScroll = () => {
	scrollY.value = scrollContainer?.scrollTop ?? window.scrollY
}


// 計算是否顯示 Header
const shouldShowHeader = computed(() => {
	return true
})

onMounted(() => {
	scrollContainer = document.querySelector('.main-content') ?? window
	scrollContainer.addEventListener('scroll', handleScroll)
})
onUnmounted(() => {
	scrollContainer?.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.navbar {
	z-index: 999;
	position: fixed;
	width: 100%;
	padding: 0.6em;
	height: auto;
	// background: linear-gradient(90deg, #108597 0%, #21B732 100%);
	&.scrolled {
		backdrop-filter: blur(10px);
		background-color: rgba(255, 255, 255, 0.2);
	}
	.container-fluid {
		padding: 0em;
		height: auto;

		&.sales-mode {
			display: flex;
			justify-content: center;
		}
		.navbar-link {
			z-index: 1;
			img {
				width: 4.4rem;
				display: flex;
			}
		}

		.navbar-toggler {
			border: none;
			color: #7bbac1;
			width: 2.4em;
			height: 1.3em;
			position: absolute;
			right: 2%;
			top: 7%;
			cursor: pointer;
			z-index: 1;
			.navbar-toggler-icon {
				background-image: none;
				display: inline-flex;
				position: relative;
				width: 1.5em;
				height: 0.1em;
				background-color: #7bbac1;

				&::before,
				&::after {
					content: '';
					position: absolute;
					width: 1.5em;
					height: 0.1em;
					background-color: #7bbac1;
				}

				&::before {
					top: -0.4em;
				}

				&::after {
					top: 0.4em;
				}

				&.active {
					background-color: transparent;

					&::before {
						top: 0;
						transform: rotate(45deg);
					}

					&::after {
						top: 0;
						transform: rotate(-45deg);
					}
				}
			}

			img {
				width: 2.4rem;
				// height: 2.4em; // 保持寬高比
				// max-width: 48px;
				// max-height: 48px;
			}
		}

		.navbar-toggler:focus {
			text-decoration: none;
			outline: 0;
			box-shadow: none;
		}

		.collapse {
			background-image:
				linear-gradient(0deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%),
				url('https://lineevent.s3.ap-northeast-1.amazonaws.com/Vespa_New180/images/bg/collapse-bg.png');
			background-position: top center;
			background-repeat: no-repeat;
			background-size: cover;

			width: 100vw;
			height: 100vh;
			position: fixed;
			top: 0em;
			left: 0%;
			padding: 0em 2.2em;
			overflow: hidden;
			z-index: -1;
		}
	}
}

.navbar-nav {
	position: relative;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -30%);
	height: 100%; /* 讓它佔滿 collapse 的高度 */
	margin: 0;
	padding: 0;
	list-style: none;
	.nav-item {
		width: 100%;
		padding: 1em;
		border-bottom: 1.2px solid rgba(147, 174, 176, 0.4);
		text-align: center;
		color: #2a797f;
		text-align: center;
		font-size: 1.2em;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		letter-spacing: 1.92px;
		z-index: 4;
		button {
			text-decoration: none; /* ✅ 去除底線 */
			/* 或直接指定你要的顏色 */
			color: #2a797f;
			line-height: 1.2em;
		}
	}
}
</style>

<!-- 插下拉選班背景漸層色怎麼做 -->
